import axiosClient from "../axios/axiosClient";

export function getSessions() {
  return axiosClient.get("/sessions");
}

export function getSession(sessionId) {
  return axiosClient.get(`/sessions/${sessionId}`);
}

export function createSession(data) {
  return axiosClient.post("/sessions", data);
}

export const updateSession = (sessionId, data) => {
  return axiosClient.put(`/sessions/${sessionId}`, data);
};

export function deleteSession(sessionId) {
  return axiosClient.delete(`/sessions/${sessionId}`);
}
